// extracted by mini-css-extract-plugin
module.exports = {"landing_page":"style_landing_page__1uhJm","pic":"style_pic__1bPeJ","intro_name":"style_intro_name__3UF7g","tagline":"style_tagline__1Fswk"};